import { render, staticRenderFns } from "./StarterKit.vue?vue&type=template&id=230ac677&scoped=true&"
import script from "./StarterKit.vue?vue&type=script&lang=js&"
export * from "./StarterKit.vue?vue&type=script&lang=js&"
import style0 from "./StarterKit.vue?vue&type=style&index=0&id=230ac677&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230ac677",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('230ac677')) {
      api.createRecord('230ac677', component.options)
    } else {
      api.reload('230ac677', component.options)
    }
    module.hot.accept("./StarterKit.vue?vue&type=template&id=230ac677&scoped=true&", function () {
      api.rerender('230ac677', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StarterKit.vue"
export default component.exports